import React, { Component } from 'react';
import './App.css';
import Quakesmap from './QuakesMap';
import mapLegend from './Images/LEGEND'; //This is not working once built, why?
import bslLogo from './Images/BSL';
import burgerMenu from './Images/burgerMenu.png';

var clicks = 0;

class App extends Component {
  constructor() {
    super() // For some reason you do need to call super even if you do not wish to access parent props
    this.state = {
      data: [],
      filteredData: [],
      urlString: "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_week.geojson",
      selectedButton: "2Plus",
      selectedFaults: "none",
      loading: "Loading initial quakes..."
    }; // set some initial state

  }
  // reloads the page with the current selection
  startTimerThing = () => {
    var myTimerVar = setInterval(() => {
      this.updateQuakes()
    }, 60000);
  }
  // callback to pass up "quakes loading" message
  quakesLoading = messageFromChild => {
    //console.log("Quakes loading callback called in App")
    this.setState({
    loading : messageFromChild
      }, function(){ 
      //console.log("Quakes loading callback called in App and set the state")
    })    
  }
  handleBurgerMenuXClick = () => {
    if ((clicks%2)===1){
      document.getElementById('burgerMenu').style.display = 'block';
      document.getElementById('closeMe').style.display = 'none';
      document.getElementById('buttonContainer').style.display = 'none';
    } else {
      document.getElementById('burgerMenu').style.display = 'none';
      document.getElementById('closeMe').style.display = 'block';
      document.getElementById('buttonContainer').style.display = 'block';
    }   
    clicks++;
  }
  // event handlers often named handle
  // THese could be just one function probably
  // These are arrow functions that automatically bind their code to the surrounding context, new JS thing
  // ie their this is the this of the enclosing lexical context
  handleLoad2PlusClick = () =>{
    this.setState({
      urlString: "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/2.5_week.geojson",
      selectedButton:'2Plus',
      loading: 'Loading quakes M2.5+, past week'
    }, function(){
      document.getElementById('quakesUpdated').style.display = 'block';
      this.getQuakes(this.state.urlString)
    })
  }
  handleLoadDayAllClick = () =>{
    this.setState({
      urlString: "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_day.geojson",
      selectedButton:'DayAll',
      loading: 'Loading all quakes, past day'
    }, function(){
      document.getElementById('quakesUpdated').style.display = 'block';
      this.getQuakes(this.state.urlString)
    })
  }
  handleLoadWeekAllClick = () =>{
    this.setState({
      urlString: "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_week.geojson",
      selectedButton:'WeekAll',
      loading: 'Loading all quakes, past week'
    }, function(){
      document.getElementById('quakesUpdated').style.display = 'block';
      this.getQuakes(this.state.urlString)
    })
  }
  handleLoadFaultsClick = () =>{
    if (this.state.selectedFaults !== 'Faults')
      this.setState({
        selectedFaults:'Faults',
      }, function(){
        //
      })
    else {
      this.setState({
        selectedFaults:'none',
      }, function(){
        //
      })
    }
  }
  getInitialQuakes = () => {
    this.getQuakes(this.state.urlString)
  }
  updateQuakes = () => {
      this.setState({loading:"Updating quakes"}, function(){
        this.getQuakes(this.state.urlString)
        document.getElementById('quakesUpdated').style.display = 'block';
        setTimeout(function(){
          document.getElementById('quakesUpdated').style.display = 'none';
        },3000); //delay is in milliseconds 
      })  
    //})
  }
  getQuakes = (urlString) =>{
    //console.log("Starting function getQuakes")
    // This is promises, new JS thing
    fetch(urlString)
   // parses the response as a json object. It is now a standard object. .then metnod chaining similar to jquery
   // 2019/05/03 somehow when the json is parsed, there becomes a features.mag value assigned to the first 
   // array value, while there ought to be only features.id, features.properties, and features.geometry
   // this weird error is propagated down as I work with the array, eventually attaching a spurious features.mag
   // value to the first index of a filtered array. Ten I have to be very careful when finding the biggest quake
   // Looked all afternoon and have no idea why this occurs or how to fix.
      .then(res => res.json())
      .then(
        (res) => {
          this.setState({
            isLoaded: true,
            data: res 
          }, function(){
            //console.log("I just loaded the data, and the data is", JSON.stringify(this.state.data.features)) 
            this.setState(() => {
              return {filteredData: this.state.data.features.sort(function compare(a,b){
                if (a.properties.time < b.properties.time){return -1} // sort a to index < b, ie a comes first
                if (a.properties.time > b.properties.time){return 1}  
                return 0 // leaves a and b unchanged wrt each other but still sorted wrt other elements
              })}
                //function(a,b) {return (a.properties.time- b.properties.time)}
             //this.state.data.features is the array of quakes
            }, function(){
              //this.state.filteredData.forEach(function(element) {
                //console.log("Time", element.properties.time);
                //console.log("Definitely done sorting by time")
              //});
              //console.log("I'm the callback", this.state.data.features)
            })
          })
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          }); // no error handling yet
        })
  };
  // React lifecycle methods used for performance optimization
  // Detect IE and have popup when App mounts.
  componentDidMount(){
    this.getInitialQuakes();
    this.startTimerThing();
  }
  // Render in jsx. like HTML but has different rules for enclosing tags, style names, comments, can put JS in {}
  // State usially flows down in React, passing entire state down to map
  // do I really need to pass data down as prop, too?
  render() {
    return (
      <div className="App">
        <div id="burgerMenu" onClick={this.handleBurgerMenuXClick}>
          <img alt="Hamburger Menu" src={burgerMenu}/>
          {/*<img alt="Hamburger Menu" src="/BSL_template_img/burgerMenu.png" />*/}
        </div>
        <div id="buttonContainer">
          <div id="closeMe" onClick={this.handleBurgerMenuXClick}>x</div>
          <button
            style={(this.state.selectedButton === "2Plus") ? {border:'4px solid #003262'}: {border:'1px solid black'}} 
            onClick={this.handleLoad2PlusClick}>Load M2.5+, past week</button><br/>
          <button 
            style={(this.state.selectedButton === "DayAll") ? {border:'4px solid #003262'}: {border:'1px solid black'}} 
            onClick={this.handleLoadDayAllClick}>Load all, past day</button><br/>
          <button className="more"
            style={(this.state.selectedButton === "WeekAll") ? {border:'4px solid #003262'}: {border:'1px solid black'}} 
            onClick={this.handleLoadWeekAllClick}>Load all, past week<br/> (warning, slow)</button><br/>
          {/*<button
            style={(this.state.selectedFaults === "Faults") ? {border:'4px solid #003262'}: {border:'1px solid black'}} 
            onClick={this.handleLoadFaultsClick}>Load faults</button><br/>*/}
        </div>
        <div className="logoContainer">
          {/*<img className="bslLogo" alt="BSL Logo" src={bslLogo}/><br/>
          <img className="mapLegend" alt="Map Legend" src={mapLegend}/><br/>*/}
          {/*for BSL, logo path is /BSL_template_img/BSL, legend path is /BSL_template_img/LEGEND*/}
          {/*for CISN, logo path is /images/CISN_Logo_EQMap.png , legend path is /images/LEGEND*/}
          <img className="bslLogo" alt="BSL Logo" src="/BSL_template_img/BSL" /><br/>
          <img className="mapLegend" alt="Map Legend" src="/BSL_template_img/LEGEND" /><br/>
          {/*<img className="bslLogo" alt="CISN Logo" src="/images/CISN_Logo_EQMap.png" /><br/>*/}
          {/*<img className="mapLegend" alt="Map Legend" src="/images/LEGEND" /><br/>*/}
        </div>
        <div id="quakesUpdated">
          <p>{this.state.loading}</p>
        </div>
        <div style={{position:'absolute',right:'0px',top:'0px',bottom:'0px', left:'0px', height: '100%', width: '100vw'}}>
          <Quakesmap {...this.state} cb={this.quakesLoading}/>
        </div>
      </div>
    );
  }
}  

// What does this really mean? Is this only for Webpack?
export default App;
